export default __webpack_public_path__ + "static/media/last_page_icon.2614de93.svg";